import { isCompanionEvent, isTransportEvent } from "./guestTypeUtils";

/** Marca las entradas de `employeeConfirmationsData` sembradas desde la autorización de transporte,
 * para poder retirarlas si el guardia vuelve a "Transporte" o cambia de tipo. */
export const INHERITED_FROM_TRANSPORT = "inheritedFromTransport";

/**
 * Empresa + anfitrión con los que entró un chofer de transporte, listos para sembrarlos como
 * confirmación en guardia cuando sale a pie y el guardia lo egresa como visita, contratista o
 * eventual.
 *
 * Sale de la autorización de transporte de ingreso del evento —la misma que resuelve
 * `getEntryTransportAuthorization`—, igual que en el egreso de visitas y contratistas se hereda lo
 * que trae el evento de ingreso. El acompañante no entra por acá: su confirmación ya viene en
 * `invites` (ver buildDefaultEntryRegistrationValues).
 *
 * Devuelve `null` si no hay anfitrión resoluble (autorización aprobada por el guardia sin persona
 * asociada): el backend sólo acepta `host: null` para el acompañante, así que no hay nada que
 * heredar y el guardia elige a mano.
 */
export const buildTransportInheritedConfirmation = (entranceEvent: any) => {
  if (!entranceEvent || !isTransportEvent(entranceEvent) || isCompanionEvent(entranceEvent)) {
    return null;
  }

  const event = entranceEvent.event || entranceEvent;
  const authorizations: any[] = event.transportAuthorizations || [];
  const authorization =
    authorizations.find((auth) => auth?.eventType === "in") ?? authorizations[0];

  const host = authorization?.host;
  const hostId = host?.user || host?.id;
  const company = authorization?.company;
  if (!hostId || !company) return null;

  return {
    confirmation: { host: hostId as string, company: company as string },
    // Misma forma que una confirmación en guardia del evento (`type: "guard"`), que es la que
    // `AuthorizationsSection` sabe mostrar en "Seleccionado en guardia".
    data: {
      type: "guard",
      id: `transport-${authorization.id}`,
      host: {
        id: hostId,
        firstname: host.firstname,
        lastname: host.lastname,
        phone: host.phone,
      },
      company,
      [INHERITED_FROM_TRANSPORT]: true,
    },
  };
};
